/* Paginas simples (Contacto, Proximamente, paginas de texto): registro de
   bloques por recorte + desregistro del titulo si lo hay. */
const { mount, registrar, desregistro, reveal } = window.EQ;
mount('[data-eq-pagina]', (root) => {
  const unreg = registrar(root);
  const rev = reveal(root);
  const des = root.querySelector('[data-eq-desreg]');
  if (des) desregistro(des, true);
  return () => { unreg(); rev.destroy(); };
});
